import Swal from "sweetalert2";

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
  url_json = url_json.local;
} else {
  url_json = url_json.production;
}

const Autores = {
  agregarAutor: async (data) => {
    let url = url_json + "/autor-blog";
    let body = {
      nombre: data.nombre,
      certificado: data.certificado,
      imagen: data.imagen,
    };

    let request = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let res = await response.json();

    if (response.ok) {
      Swal.fire(
        "Inserción exitosa!",
        "Autor agregado correctamente",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el autor, codigo: " + res.message,
        "error"
      ).then(() => {
        window.location.reload();
      });
    }
    return { success: response.ok, data: res.data, code: res.message };
  },
  obtnenreAutores: async () => {
    let url = url_json + "/autor-blog";
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  obtenerUnAutor: async (id) => {
    let url = url_json + "/autor-blog/" + id;
    let request = {
      method: "GET",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let json = await response.json();
    return { success: response.ok, data: json.data, code: json.message };
  },
  editarAutor: async (data, id) => {
    let url = url_json + "/autor-blog/" + id;

    let body = {
      nombre: data.nombre,
      certificado: data.certificado,
      imagen: data.imagen,
    };

    let request = {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Modificación exitosa!",
        "Autor modificado correctamente",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire("Error!", "No se pudo modificar el autor", "error").then(
        () => {
          window.location.reload();
        }
      );
    }
    return { success: response.ok, data: res.data };
  },
  eliminarAutor: async (id) => {
    let url = url_json + "/autor-blog/delete/" + id;
    let request = {
      method: "PATCH",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    };

    let response = await fetch(url, request);
    let res = await response.json();
    if (response.ok) {
      Swal.fire(
        "Eliminación exitosa!",
        "Autor eliminado correctamente",
        "success"
      ).then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire("Error!", "No se pudo eliminar el autor", "error").then(
        () => {
          window.location.reload();
        }
      );
    }
    return { success: response.ok, data: res.data };
  },
};

export default Autores;
